interface LoadScriptOptions {
  scriptId?: string;
  insertBeforeAllTags?: boolean;
  defer?: boolean;
  type?: string | null;
}

export async function loadScript(
  src: string,
  { scriptId = '', insertBeforeAllTags = false, defer = false, type = null }: LoadScriptOptions = {}
): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = scriptId;
    script.onload = () => {
      resolve();
    };
    script.onerror = (event: Event | string) => {
      const target = event instanceof Event ? (event.target as HTMLScriptElement) : null;
      reject(new ExternalScriptError(target?.src ?? src));
    };
    script.src = src;
    if (defer) script.defer = true;
    if (type) script.type = type;

    if (insertBeforeAllTags) {
      const firstScriptTagInDocument = document.getElementsByTagName('script')[0];
      if (firstScriptTagInDocument?.parentNode) {
        firstScriptTagInDocument.parentNode.insertBefore(script, firstScriptTagInDocument);
      } else {
        document.body.appendChild(script);
      }
    } else {
      document.body.appendChild(script);
    }
  });
}

export class ExternalScriptError extends Error {
  url: string;

  constructor(url: string) {
    const message = `Failed to load script at ${url}`;
    super(message);
    this.name = 'ExternalScriptError';
    this.url = url;
  }
}
